/* eslint-disable indent */
/* eslint-disable key-spacing */
/* eslint-disable no-dupe-keys */
// 收货方主数据-->中英文
export const Report = {
    'zhCN': {
        receiverReport: {
            reportAll: '总计',
            reportMonth: '按月总汇',
            receiverProvinceName: '收货方省份',
            productName: '产品简称',
            materialGroupName: '分型名称',
            distributorProvinceName: '发货方省份',
            distributorCityName: '发货方城市',
            distributorTypeGroup: '发货方类型Group',
            distributorType: '发货方类型',
            receiverType: '收货方类型',
            distributorName: '发货方名称',
            distributorPHCode: '发货方PHCode',
            employeeName: '负责人',
            averageCount: '平均',
            month: '月份',
            tradeType: '销售类型',
            totalCount: '总数',
            totalSalesAmount: '销售金额合计：',
            totalLYSalesAmount: 'LY销售金额合计：'
        },
        distributorReport: {
            isShowTargetHospital: '是否展示目标医院',
            isShowCity: '是否展示城市'
        }
    },
    'enUS': {
        receiverReport: {
            reportAll: 'Total',
            reportMonth: 'Monthly Summary',
            receiverProvinceName: 'Receiving Province',
            productName: 'Product',
            materialGroupName: 'Type Name',
            distributorProvinceName: 'Distributor Province',
            distributorCityName: 'Distributor city',
            distributorTypeGroup: 'Distributor Type Group',
            distributorType: 'Distributor Type',
            receiverType: 'Receiver Type',
            distributorName: 'Distributor Name',
            distributorPHCode: 'Distributor PHCode',
            employeeName: 'Principal',
            averageCount: 'Average',
            month: 'Month',
            tradeType: 'Type of sales',
            totalCount: 'Total',
            totalSalesAmount: 'Total Sales Amount: ',
            totalLYSalesAmount: 'Last Year Total Sales Amount: ：'
        },
        distributorReport: {
            isShowTargetHospital: 'Show TargetHospital',
            isShowCity: 'Show City'
        }
    }
}
export default Report



// WEBPACK FOOTER //
// ./src/locale/modules/reportLocale.js